export function getPlaylistBadgeType(publishedAt: string | null | undefined): 'today' | 'yesterday' | 'this-week' | null {
  if (!publishedAt) return null;

  const now = new Date();
  const published = new Date(publishedAt);
  
  // Reset time to start of day for accurate comparison
  const todayStart = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const yesterdayStart = new Date(todayStart);
  yesterdayStart.setDate(yesterdayStart.getDate() - 1);
  const weekAgoStart = new Date(todayStart);
  weekAgoStart.setDate(weekAgoStart.getDate() - 7);
  
  // Reset published time to start of day
  const publishedStart = new Date(published.getFullYear(), published.getMonth(), published.getDate());
  
  if (publishedStart.getTime() === todayStart.getTime()) {
    return 'today';
  } else if (publishedStart.getTime() === yesterdayStart.getTime()) {
    return 'yesterday';
  } else if (publishedStart > weekAgoStart) {
    return 'this-week';
  }
  
  return null;
}